import LocationOpenedLayout from "../../components/layouts/LocationOpenedLayout";
import {getCookiePreferences} from "../../helpers/cookies";
import LocationClosedLayout from "../../components/layouts/LocationClosedLayout";
import {locationData} from "../../helpers/locations";
import {getInitialTrialSlots} from "../../helpers/api/trial-slots";

export default function Location({slug, trialSlotsResponse, hasCookiePreferences, cookiePreferences}) {
    if (locationData[slug].status === 'opened') {
        return (
            <LocationOpenedLayout data={locationData[slug]}
                                location={slug}
                                hasCookiePreferences={hasCookiePreferences}
                                cookiePreferences={cookiePreferences}
                                trialSlotsResponse={trialSlotsResponse}
            />
        );
    }

    return (
        <LocationClosedLayout data={locationData[slug]}
                            location={slug}
                            hasCookiePreferences={hasCookiePreferences}
                            cookiePreferences={cookiePreferences}
                            trialSlotsResponse={trialSlotsResponse}
        />
    );
}

export async function getServerSideProps({req, query, res}) {
    const cookiePreferences = getCookiePreferences(req);
    const trialSlots = await getInitialTrialSlots();

    return {
        props: {
            trialSlotsResponse: trialSlots,
            slug: query.slug,
            ...cookiePreferences,
        }
    }
}
